module.exports = __webpack_public_path__ + "img/iripple-helpdesk-light.b47f6d5e.png";